import React, { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true); // أضف هذا

  const saveToken = (newToken) => {
    setToken(newToken);
    localStorage.setItem("authToken", newToken);
  };

  useEffect(() => {
    const storedToken = localStorage.getItem("authToken");
    if (storedToken) {
      setToken(storedToken);
    }
    setLoading(false); // بعد الانتهاء من الفحص
  }, []);

  const logout = () => {
    setToken(null);
    localStorage.removeItem("authToken");
  };

  return (
    <AuthContext.Provider value={{ token, saveToken, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
